import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import {
  SummaryRowBox,
  SummaryRowIcon,
  SummaryRowContent,
  SummaryRowLabel,
  SummaryRowValue,
  SummaryRowDetail,
  SummaryRowEditButton,
} from './styled';

interface SummaryRowProps {
  icon: ReactNode;
  label: string;
  value: ReactNode;
  detail?: ReactNode;
  onEdit?: () => void;
  children?: ReactNode;
}

const SummaryRow = ({
  icon,
  label,
  value,
  detail,
  onEdit,
  children,
}: SummaryRowProps) => {
  const { t } = useTranslation('common');

  return (
    <SummaryRowBox>
      <SummaryRowIcon>{icon}</SummaryRowIcon>
      <SummaryRowContent>
        <SummaryRowLabel>{label}</SummaryRowLabel>
        <SummaryRowValue>{value}</SummaryRowValue>
        {detail && <SummaryRowDetail>{detail}</SummaryRowDetail>}
        {children}
      </SummaryRowContent>
      {onEdit && (
        <SummaryRowEditButton onClick={onEdit} size="small">
          {t('assistant.scriptDialog.wizard.editSection')}
        </SummaryRowEditButton>
      )}
    </SummaryRowBox>
  );
};

export default SummaryRow;
